// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  CustomFieldCollectionOutput,
  CustomFieldCollectionOutputFromJSON,
  CustomFieldCollectionOutputToJSON,
  Step,
  StepFromJSON,
  StepToJSON,
  StepParsed,
  StepParsedFromJSON,
  StepParsedToJSON,
} from "./";

/**
 *
 * @export
 * @interface TestCaseMinified
 */
export interface TestCaseMinified {
  /**
   *
   * @type {number}
   * @memberof TestCaseMinified
   */
  id: number;
  /**
   * Per-company sequential business id, surfaced in the UI as TC-<n>
   * @type {number}
   * @memberof TestCaseMinified
   */
  displayNumber?: number;
  /**
   *
   * @type {string}
   * @memberof TestCaseMinified
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof TestCaseMinified
   */
  suite?: number;
  /**
   * Test case description (generated by rich text editor)
   * @type {string}
   * @memberof TestCaseMinified
   */
  description: string;
  /**
   *
   * @type {Array<Step>}
   * @memberof TestCaseMinified
   */
  steps?: Array<Step>;
  /**
   *
   * @type {Array<StepParsed>}
   * @memberof TestCaseMinified
   */
  stepsParsed?: Array<StepParsed>;
  /**
   * Priority, 0 - Low, 1- Normal, 2 - High
   * @type {number}
   * @memberof TestCaseMinified
   */
  priority: TestCaseMinifiedPriorityEnum;
  /**
   * Array of custom fields
   * @type {Array<CustomFieldCollectionOutput>}
   * @memberof TestCaseMinified
   */
  customFields?: Array<CustomFieldCollectionOutput>;
  /**
   *
   * @type {string}
   * @memberof TestCaseMinified
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof TestCaseMinified
   */
  updatedAt?: string;
  /**
   *
   * @type {number}
   * @memberof TestCaseMinified
   */
  createdBy?: number;
  /**
   *
   * @type {string}
   * @memberof TestCaseMinified
   */
  lastRunStatus?: string;
  /**
   *
   * @type {number}
   * @memberof TestCaseMinified
   */
  runCount?: number;
  /**
   *
   * @type {number}
   * @memberof TestCaseMinified
   */
  avgExecutionTime?: number;
  /**
   *
   * @type {string}
   * @memberof TestCaseMinified
   */
  lastRunOn?: string;
  /**
   * Test failure percentage
   * @type {number}
   * @memberof TestCaseMinified
   */
  failureRate?: number;
  /**
   * True when the test case is managed by BDD sync from a scenario in a feature file in Git.
   * @type {boolean}
   * @memberof TestCaseMinified
   */
  readonly isBddManaged?: boolean;
  /**
   * Will be true only for links
   * @type {boolean}
   * @memberof TestCaseMinified
   */
  isReference?: boolean;
  /**
   * Only for links - source entity ID
   * @type {number}
   * @memberof TestCaseMinified
   */
  sourceId?: number;
  /**
   * Only for links - source Project ID
   * @type {number}
   * @memberof TestCaseMinified
   */
  sourceProject?: number;
  /**
   * 1 if test case is under review else 0  (applicable when test case review feature is enabled)
   * @type {number}
   * @memberof TestCaseMinified
   */
  underReview?: number;
  /**
   * Can be considered for execution by copilot (applicable when test case automation feature is enabled)
   * @type {number}
   * @memberof TestCaseMinified
   */
  isAutomated?: number;
  /**
   * Can be considered for execution by copilot (applicable when test case automation feature is enabled)
   * @type {number}
   * @memberof TestCaseMinified
   */
  qacTimeout?: number;
}

export function TestCaseMinifiedFromJSON(json: any): TestCaseMinified {
  return {
    id: json["id"],
    displayNumber: !exists(json, "display_number")
      ? undefined
      : json["display_number"],
    title: json["title"],
    suite: !exists(json, "suite") ? undefined : json["suite"],
    description: json["description"],
    steps: !exists(json, "steps")
      ? undefined
      : (json["steps"] as Array<any>).map(StepFromJSON),
    stepsParsed: !exists(json, "steps_parsed")
      ? undefined
      : (json["steps_parsed"] as Array<any>).map(StepParsedFromJSON),
    priority: json["priority"],
    customFields: !exists(json, "custom_fields")
      ? undefined
      : (json["custom_fields"] as Array<any>).map(
          CustomFieldCollectionOutputFromJSON
        ),
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
    createdBy: !exists(json, "created_by") ? undefined : json["created_by"],
    lastRunStatus: !exists(json, "last_run_status")
      ? undefined
      : json["last_run_status"],
    runCount: !exists(json, "run_count") ? undefined : json["run_count"],
    avgExecutionTime: !exists(json, "avg_execution_time")
      ? undefined
      : json["avg_execution_time"],
    lastRunOn: !exists(json, "last_run_on") ? undefined : json["last_run_on"],
    failureRate: !exists(json, "failure_rate")
      ? undefined
      : json["failure_rate"],
    isBddManaged: !exists(json, "is_bdd_managed")
      ? undefined
      : json["is_bdd_managed"],
    isReference: !exists(json, "is_reference")
      ? undefined
      : json["is_reference"],
    sourceId: !exists(json, "source_id") ? undefined : json["source_id"],
    sourceProject: !exists(json, "source_project")
      ? undefined
      : json["source_project"],
    underReview: !exists(json, "under_review")
      ? undefined
      : json["under_review"],
    isAutomated: !exists(json, "is_automated")
      ? undefined
      : json["is_automated"],
    qacTimeout: !exists(json, "qac_timeout") ? undefined : json["qac_timeout"],
  };
}

export function TestCaseMinifiedToJSON(value?: TestCaseMinified): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    display_number: value.displayNumber,
    title: value.title,
    suite: value.suite,
    description: value.description,
    steps:
      value.steps === undefined
        ? undefined
        : (value.steps as Array<any>).map(StepToJSON),
    steps_parsed:
      value.stepsParsed === undefined
        ? undefined
        : (value.stepsParsed as Array<any>).map(StepParsedToJSON),
    priority: value.priority,
    custom_fields:
      value.customFields === undefined
        ? undefined
        : (value.customFields as Array<any>).map(
            CustomFieldCollectionOutputToJSON
          ),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    created_by: value.createdBy,
    last_run_status: value.lastRunStatus,
    run_count: value.runCount,
    avg_execution_time: value.avgExecutionTime,
    last_run_on: value.lastRunOn,
    failure_rate: value.failureRate,
    is_reference: value.isReference,
    source_id: value.sourceId,
    source_project: value.sourceProject,
    under_review: value.underReview,
    is_automated: value.isAutomated,
    qac_timeout: value.qacTimeout,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum TestCaseMinifiedPriorityEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
}
